<template>
  <footer class="global-footer">
    <div class="footer-main">
      <div class="footer-grid">
        <div class="footer-col">
          <h4>iPastBook</h4>
          <p class="footer-desc">{{ $t('home.footerCompanyDesc') }}</p>
          <div class="footer-locale">
            <div class="locale-group">
              <label for="footer-lang">{{ $t('home.footerLanguage') }}</label>
              <select id="footer-lang" class="locale-select" :value="language" @change="handleLanguage">
                <option :value="i.code" v-for="i in languages" :key="i.code">{{ i.title }}</option>
              </select>
            </div>
          </div>
          <div class="footer-social">
            <a href="https://www.facebook.com/iPastBookBot/" target="_blank" rel="noopener" aria-label="Facebook">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a href="https://www.instagram.com/ipastbook/" target="_blank" rel="noopener" aria-label="Instagram">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
            </a>
            <a href="https://x.com/ipastbook" target="_blank" rel="noopener" aria-label="X">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
          </div>
        </div>

        <div class="footer-col footer-links">
          <h4>{{ $t('home.footerProducts') }}</h4>
          <ul>
            <li><router-link to="/products?type=diarybook">{{ $t('home.footerProduct') }}</router-link></li>
            <li><a href="/2.0/products?type=diarybook#pricing">{{ $t('header.navPricing') }}</a></li>
            <li><a href="javascript:;" @click="handleCreateBook">{{ $t('home.footerStartBtn') }}</a></li>
          </ul>
        </div>

        <div class="footer-col footer-links">
          <h4>{{ $t('home.footerSupport') }}</h4>
          <ul>
            <li><a href="/2.0/#home-faq">{{ $t('home.footerFAQ') }}</a></li>
            <li><router-link to="/privacy">{{ $t('home.footerPrivacy') }}</router-link></li>
            <li><router-link to="/terms">{{ $t('home.footerTerms') }}</router-link></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="container footer-bottom-inner">
        <div class="payment-icons">
          <img src="../../../static/images/home/visa-curved-128px.png" alt="Visa">
          <img src="../../../static/images/home/mastercard-curved-128px.png" alt="Mastercard">
          <img src="../../../static/images/home/american-express-curved-128px.png" alt="American Express">
        </div>
        <div class="copyright">
          &copy; 2014-{{ currentYear }} iPastBook. {{ $t('home.footerCopyright') }}
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import 'src/styles/layout/Footer.scss'
import countries from '../../../static/json/country.json'

export default {
  name: 'home-footer',
  data () {
    return {
      countries: countries.filter(i => ['US', 'TW', 'HK', 'MO'].includes(i.alias))
    }
  },
  computed: {
    ...mapGetters([
      'locale', 'language', 'user', 'messages'
    ]),
    languages () {
      return Object.keys(this.messages).map(k => {
        return {
          code: k,
          title: (this.messages[k] && this.messages[k].language) || k
        }
      })
    },
    currentYear () {
      return new Date().getFullYear()
    },
    pageLink () {
      return 'https://www.facebook.com/iPastBookBot/'
    }
  },
  methods: {
    ...mapActions([
      'setLocale', 'setLanguage', 'setLoginShow'
    ]),
    handleLanguage (e) {
      const language = e.target.value
      this.setLanguage(language)
      window.location.reload()
    },
    handleLocale (e) {
      const locale = e.target.value
      this.setLocale(locale)
      window.location.reload()
    },
    handleCreateBook () {
      const route = this.$route && this.$route.name
      if (route === 'home' || route === 'products') {
        this.$root.$emit('show-social-modal')
      } else {
        this.setLoginShow(true)
      }
    }
  }
}
</script>
